import { lazy, Suspense } from 'react';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Navigate,
	Outlet,
	Route as RouteDom,
	Routes as Switch,
} from 'react-router-dom';

import { Endpoints as EP } from './endpoint.config';
import PrivateRoute from './privateRoute';

// Lazy-loaded pages — chargées uniquement quand la route est activée
const CodePage                = lazy(() => import('../pages/mobile/codePage'));
const ConfirmationPage        = lazy(() => import('../pages/mobile/confirmationPage'));
const CredentialsPage         = lazy(() => import('../pages/desktop/credentialsPage'));
const DashboardPage           = lazy(() => import('../pages/desktop/dashboardPage'));
const HomePage                = lazy(() => import('../pages/desktop/loginPage'));
const LandingPage             = lazy(() => import('../pages/mobile/landingPage'));
const LogoutPage              = lazy(() => import('../pages/mobile/logoutPage'));
const NotFoundPage            = lazy(() => import('../pages/desktop/notFoundPage'));
const PlasmaAvailability      = lazy(() => import('../pages/plasma/plasmaAvailabilityPage'));
const QrScannerPage           = lazy(() => import('../pages/mobile/qrScannerPage'));
const RightPage               = lazy(() => import('../pages/desktop/rightPage'));
const SelectionPage           = lazy(() => import('../pages/mobile/selectionPage'));
const SemSettingPage          = lazy(() => import('../pages/desktop/espace3/settingSemPage'));
const SettingPage             = lazy(() => import('../pages/desktop/settingPage'));
const SolvedIncidentReportPage = lazy(() => import('../pages/desktop/solvedIncidentReportPage'));
const SpecialOperationPage    = lazy(() => import('../pages/desktop/specialOperationPage'));
const specialOperationRsPage  = lazy(() => import('../pages/desktop/specialOperationRsPage'));
const STTrackingBoardPage     = lazy(() => import('../pages/desktop/espace3/trackingStPage'));
const SuccessPage             = lazy(() => import('../pages/mobile/sucessSemPage'));
const TrackingRsPage          = lazy(() => import('../pages/desktop/trackingRsPage'));
const usedRSPage              = lazy(() => import('../pages/desktop/usedRsPage'));

const RootLayout = () => (
	<Suspense fallback={null}>
		<Outlet />
	</Suspense>
);

export const routeElements = (
	<RouteDom element={<RootLayout />}>
		<RouteDom element={<HomePage />} path={EP.LOGIN} />
		<RouteDom element={<LogoutPage />} path={EP.LOGOUT} />
		<RouteDom
			element={<PrivateRoute Component={LandingPage} path={EP.AGENTN} />}
			path={EP.AGENTN}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={SelectionPage} path={EP.AGENTN_SELECTION} />
			}
			path={EP.AGENTN_SELECTION}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={QrScannerPage} path={EP.AGENTN_QR_SCANNER} />
			}
			path={EP.AGENTN_QR_SCANNER}
		/>
		<RouteDom
			element={<PrivateRoute Component={CodePage} path={EP.AGENTN_BY_CODE} />}
			path={EP.AGENTN_BY_CODE}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={ConfirmationPage} path={EP.AGENTN_CONFIRM} />
			}
			path={EP.AGENTN_CONFIRM}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={SuccessPage} path={EP.AGENTN_SUCCESS} />
			}
			path={EP.AGENTN_SUCCESS}
		/>
		<RouteDom
			element={<PrivateRoute Component={SpecialOperationPage} path={EP.OP} />}
			path={EP.OP}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={specialOperationRsPage} path={EP.OPRS} />
			}
			path={EP.OPRS}
		/>
		<RouteDom
			element={
				<PrivateRoute
					Component={TrackingRsPage}
					path={EP.TRACKING_BOARD_RS}
				/>
			}
			path={EP.TRACKING_BOARD_RS}
		/>
		<RouteDom
			element={
				<PrivateRoute
					Component={STTrackingBoardPage}
					path={EP.TRACKING_BOARD_ST}
				/>
			}
			path={EP.TRACKING_BOARD_ST}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={CredentialsPage} path={EP.HABILITATION} />
			}
			path={EP.HABILITATION}
		/>
		<RouteDom
			element={<PrivateRoute Component={DashboardPage} path={EP.REPORTING} />}
			path={EP.REPORTING}
		/>
		<RouteDom
			element={
				<PrivateRoute
					Component={SolvedIncidentReportPage}
					path={EP.SOLVEDINCIDENTREPORT}
				/>
			}
			path={EP.SOLVEDINCIDENTREPORT}
		/>
		<RouteDom
			element={<PrivateRoute Component={SettingPage} path={EP.SETTING} />}
			path={EP.SETTING}
		/>
		<RouteDom
			element={
				<PrivateRoute Component={SemSettingPage} path={EP.SEMSETTING} />
			}
			path={EP.SEMSETTING}
		/>
		<RouteDom
			element={<PrivateRoute Component={RightPage} path={EP.RIGHT} />}
			path={EP.RIGHT}
		/>
		<RouteDom
			element={<PrivateRoute Component={usedRSPage} path={EP.USED_RS} />}
			path={EP.USED_RS}
		/>
		<RouteDom
			element={<PrivateRoute Component={PlasmaAvailability} path={EP.PLASMA_AVAILABILITY} />}
			path={EP.PLASMA_AVAILABILITY}
		/>
		<RouteDom element={<NotFoundPage />} path="/404" />
		<RouteDom element={<Navigate to="/404" />} path="*" />
	</RouteDom>
);

export const router = createBrowserRouter(
	createRoutesFromElements(routeElements)
);

export const Routes = () => {
	return (
		<Suspense fallback={null}>
			<Switch>{routeElements}</Switch>
		</Suspense>
	);
};

export default Routes;
